// Global dependencies
import $ from 'jquery'
import "jquery-ui-dist/jquery-ui";

window.$ = window.jQuery = $;

import 'bootstrap';

console.log("jQuery loaded:", typeof $);
console.log("jQuery version:", $.fn.jquery);


import Rails from "@rails/ujs";

Rails.start();


// import "src/frontend/alert_payment_status";

import "src/frontend/inline_boot";
import "../channels/chat_channel"
import "../channels/gbr_channel"
import "../channels/badge_channel"

// import "src/frontend/design";
import 'src/frontend/design';
import "src/frontend/fe_tracking_modal";
import "../vendor/address-picker/typeahead-addresspicker"
import 'corejs-typeahead/dist/typeahead.jquery'
import "../src/frontend/business";

import "../src/frontend/jquery.star-rating-svg";
import "src/frontend/feedback";
import "src/frontend/give_back_requests_new";
import "src/frontend/init";
import "src/frontend/js.cookie";


import "../src/frontend/chat_attach";

// Chartkick + Chart.js via npm
import "chartkick/chart.js";

// Underscore
import "underscore";


// Cocoon (se lo usi lato JS, valuta la variante npm o mantieni per ora l’uso via gem/Sprockets)
//// import "cocoon-js" // se disponibile; altrimenti lascia Sprockets temporaneamente

// Action Cable
import * as ActionCable from "@rails/actioncable";

window.ActionCable = ActionCable;

// I tuoi init
import "src/frontend/init";
import "../src/validator";
import "../src/insured_shipping.js";
import "../src/pickup_address.js";


// Se hai canali ActionCable convertiti in ES modules, importa i consumer:
// import "../channels/consumer";
// import "../channels/index";
// Per l’equivalente di require_tree ../channels, importa ogni file canale esplicitamente.

// Vendor vari: cerca le controparti npm o importa da app/javascript/vendor
// es. import "fancybox"; import "waypoints/lib/jquery.waypoints.js"; etc.
// Remapped from app/assets/javascripts/frontend/scripts.js manifest:
import "jquery.fancybox";
import "classie";
import "typed.js";
// typewriter may not exist on npm; keep via legacy if needed
// import "typewriter";
import "waypoints/lib/jquery.waypoints.js";
import "underscore"; // already imported above; kept for clarity
// typeahead bundles
import "corejs-typeahead";
import "src/remote_checks";
import PasswordStrengthMeter from "src/password_strength_meter";
import "src/password_toggle";

document.addEventListener('DOMContentLoaded', function () {
  
  // Password Strength Meter
  const passwordInputs = document.querySelectorAll('input[data-password-strength]');
  passwordInputs.forEach(input => {
    const wrapper = input.closest('.form-group, .form-input-group, .form-input');
    const container = wrapper ? wrapper.nextElementSibling : null;
    
    if (container && container.hasAttribute('data-password-strength-meter')) {
      const showMeter = () => {
        container.style.display = 'block';
      };

      input.addEventListener('focus', showMeter);
      input.addEventListener('input', showMeter);
      
      if (document.activeElement === input) {
        showMeter();
      }

      new PasswordStrengthMeter(input, container);
    }
  });

  // caricamento per modal sign in
  const modalDiv = document.querySelector('div[data-found-item-request-confirm]')
  if (modalDiv) {
    $(modalDiv).modal('show')
  }

  // Prevent double submission of a modal confirm link: a fast double-click would fire
  // two navigations to the same confirm URL, and the second (replayed) request can slip
  // into a different flow (e.g. from approval into hand-delivery). Disable after first click.
  const guardConfirmOnce = (modal) => {
    const confirmLink = modal.querySelector('.modal-footer a.btn-primary')
    if (!confirmLink) return
    confirmLink.addEventListener('click', (e) => {
      if (confirmLink.dataset.submitted === 'true') {
        e.preventDefault()
        return
      }
      confirmLink.dataset.submitted = 'true'
      confirmLink.classList.add('disabled')
      confirmLink.setAttribute('aria-disabled', 'true')
    })
  }

  // Special approval QR modal
  const approvalModal = document.querySelector('div[data-special-approval-confirmation]')
  if (approvalModal) {
    guardConfirmOnce(approvalModal)
    $(approvalModal).modal('show')
  }

  // Hand delivery QR modal
  const handDeliveryModal = document.querySelector('div[data-hand-delivery-confirmation]')
  if (handDeliveryModal) {
    guardConfirmOnce(handDeliveryModal)
    $(handDeliveryModal).modal('show')
  }
  
  if (document.body.classList.contains('give_back_requests-stripe_success')) {
    Promise.all([
      import("../src/frontend/gbr_payment_status")
    
    ]).then(() => {
      console.log("Search gbr-order loaded successfully");
    })
      .catch(err => {
        console.error("Error loading gbr-order scripts:", err);
      });
    
  }
  
  if (document.body.classList.contains('item_alerts-stripe_success')) {
    Promise.all([
      import("../src/frontend/alert_payment_status")
    ]).then(() => {
      console.log("script alert-order loaded successfully");
    })
      .catch(err => {
        console.error("Error loading alert-order scripts:", err);
      });
    
  }
  
  // Caricamento dinamico per pagine PUBLISH
  if (document.body.classList.contains('items-publish') ||
    document.querySelector('[data-publish-page]') ||
    window.location.pathname.includes('/publish')) {
    
    console.log("Loading publish scripts...");
    
    Promise.all([
      import ('../src/fml-bootstrap-tags/fml-bootstrap-tags'),
      import("../src/char_counter"),
      import("../src/validator"),
      import("../src/publish/publish"),
      import("../src/publish/img_preview"),
      import("../src/publish/check_exif"),
      import("../src/publish/google_maps_loader"),
    ]).then(() => {
      console.log("All publish scripts loaded successfully");
    }).catch(err => {
      console.error("Error loading publish scripts:", err);
    });
  }
  
  // Caricamento dinamico per pagine SEARCH
  if (document.body.classList.contains('items-index') ||
    document.body.classList.contains('items-search') ||
    document.querySelector('[data-search-page]') ||
    window.location.pathname.includes('/search')) {
    
    console.log("Loading search scripts...");
    
    Promise.all([
      import('corejs-typeahead/dist/typeahead.jquery.js'),
      import("../vendor/address-picker/typeahead-addresspicker.js"),
      import("../src/search/search")
      
      // import("../src/frontend/chat/gbr")
    ]).then(() => {
      console.log("Search scripts loaded successfully");
    })
      .catch(err => {
        console.error("Error loading search scripts:", err);
      });
  }
  if (document.body.classList.contains('give-back-btn') ||
    window.location.pathname.includes('/chat')) {
    
    console.log("Loading gbr scripts...");
    
    Promise.all([
      import("../src/frontend/chat/gbr")
    ]).then(() => {
      console.log("gbr scripts loaded successfully");
    })
      .catch(err => {
        console.error("Error loading gbr scripts:", err);
      });
  }
  if (document.body.classList.contains('loading-pages') || document.getElementById('next-url')) {
    
    console.log("Loading pages scripts...");
    
    Promise.all([
      import("../src/page_utilities/loading_page")
    ]).then(() => {
      console.log("pages scripts loaded successfully");
    })
      .catch(err => {
        console.error("Error loading pages scripts:", err);
      });
  }
  
});

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper', {
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 4000, // tempo in millisecondi tra slide (qui 4 secondi)
      disableOnInteraction: false // autoplay continua anche se interagisci
    }
  });

});

// Fix per webpack HMR
if (module.hot) {
  module.hot.accept();
}
